<ion-col class="jne-link" (click)="showJneInfo()">
  <ion-icon
    class="jne-link-icon"
    name="information-circle"
  ></ion-icon>
  <span class="jne-link-label">
    {{ 'WORKING_DAY.INDIVIDUAL_AGREEMENT_DAY' | translate }}
  </span>
</ion-col>
